<authority-labs-base-dialog
  [dialogRef]="dialogRef"
  [title]="title | transloco"
  [isDirty]="form.dirty"
>
  <form content nz-form nzNoColon #form="ngForm" (ngSubmit)="saveReminder()">
    <nz-form-item>
      <nz-form-label>{{
        translPath + 'reminderTitle' | transloco
      }}</nz-form-label>
      <nz-form-control>
        <input nz-input name="name" required [(ngModel)]="reminder.name" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label>{{ translPath + 'date' | transloco }}</nz-form-label>
      <nz-form-control>
        <nz-date-picker
          nzFormat="PPpp"
          [(ngModel)]="reminder.date"
          [nzShowTime]="{ nzFormat: 'HH:mm' }"
          [nzShowToday]="false"
          [nzDisabledDate]="disabledDate"
          nzMode="date"
          name="date"
          required
        ></nz-date-picker>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label>{{ translPath + 'recipient' | transloco }}</nz-form-label>
      <nz-form-control>
        <div class="recipient-wrap">
          <nz-select
            [(ngModel)]="reminder.recipientName"
            name="recipient"
            (ngModelChange)="selectedRecipient()"
          >
            <nz-option
              *ngFor="let user of usersService.users"
              [nzLabel]="user.username | username"
              [nzValue]="user.username"
            ></nz-option>
          </nz-select>

          <label
            class="private-checkbox"
            name="private"
            nz-checkbox
            [disabled]="!selectedOwner"
            [(ngModel)]="reminder.isPrivate"
            >{{ 'isPrivate' | transloco }}</label
          >
        </div>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label>{{ translPath + 'note' | transloco }}</nz-form-label>
      <nz-form-control>
        <textarea
          nz-input
          rows="2"
          #txtArea
          [value]="reminder.note || ''"
          (input)="onNoteChange(txtArea.value)"
        ></textarea>
      </nz-form-control>
    </nz-form-item>

    <p *ngIf="entity && entityId">
      *מקושר ל{{ 'entity.' + entity | transloco }} מס'
      <a class="link" [routerLink]="getLink(entity, entityId)">{{
        entityId
      }}</a>
    </p>
  </form>

  <nz-space actions>
    <ng-container nzSpaceItem>
      <button
        nz-button
        nzType="primary"
        [disabled]="disabledSaveButton(form)"
        (click)="saveReminder()"
      >
        {{ (isNewReminder ? 'button.add' : 'button.ok') | transloco }}
      </button>
    </ng-container>
  </nz-space>
</authority-labs-base-dialog>
